export const SOCIAL_LINKS = {
  facebook: "https://www.facebook.com/profile.php?id=61569844809074",
  linkedin: "https://www.linkedin.com/company/jaakko-com/",
  instagram: "https://www.instagram.com/jaakkodotcom/"
};


